import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import { FormikProps } from 'formik';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  formik: FormikProps<any>;
  name: string;
}

const FormInput = forwardRef<HTMLInputElement, InputProps>(
  ({ className, formik, name, ...props }, ref) => {
    const error = formik.errors?.[name];
    const touched = formik.touched?.[name];
    const value = formik.values?.[name] ?? '';

    return (
      <>
        <input
          ref={ref}
          name={name}
          type="text"
          className={clsx(
            'ag-w-[100px] ag-border ag-text-neutral-900 ag-border-neutral-300 ag-py-2 ag-px-3 ag-rounded-md ag-text-sm ag-outline-none ag-ring-0 focus:ag-outline-none focus:ag-ring-0 ag-bg-neutral-50',
            error && touched
              ? 'ag-text-red-900 focus:ag-border-red-500'
              : 'placeholder:ag-text-neutral-500 focus:ag-border-primary-800',
            className
          )}
          value={value}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          {...props}
        />
      </>
    );
  }
);

FormInput.displayName = 'FormInput';

export default FormInput;
